import { useEffect, useRef, useState } from 'react';
 
export default function LazySection({ children, className = '' }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
 
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: '200px',
        threshold: 0.1,
      }
    );
 
    if (ref.current) observer.observe(ref.current);
 
    return () => observer.disconnect();
  }, []);
 
  return <div ref={ref} className={className}>{show ? children : null}</div>;
}